import {Directive, ElementRef, HostListener, Input} from '@angular/core';
import {SearchResultEntry} from "../../api/models/search-result-entry";
import {AnalyticsService} from "../service/analytics/analytics.service";
import {SignalService} from "../service/signal/signal.service";

@Directive({
  selector: '[appResultClickTracking]'
})
export class ResultClickTrackingDirective {

  @Input()
  appResultClickTracking!: SearchResultEntry;

  @Input()
  sendSignal: boolean | string = true;

  @Input()
  englishDisplayString: string = "";

  @Input()
  hrefHolder: string = "";

  constructor(private el: ElementRef,
              private analyticsService: AnalyticsService,
              private signalService: SignalService) {
  }

  @HostListener('click', ['$event']) onClick($event: any) {
    const elementHref = this.hrefHolder ? this.hrefHolder : this.el.nativeElement.href;
    this.analyticsService.trackResultClick(elementHref, this.appResultClickTracking, this.englishDisplayString);
    const invokeSignalService = (typeof this.sendSignal === 'string') ? this.sendSignal !== 'false' : this.sendSignal;
    if (invokeSignalService) {
      this.signalService.sendSignal(this.appResultClickTracking, elementHref)
    }
  }


}
